import { SymptomRow } from "../../api/symptom.type";
import MedicalRecordSummaryCard from "../medical-records/medical-record-summary-card";
import { formatTimeStampToHumanReadableDate } from "../utls/time";

const interpretationToneMap: Record<string, "default" | "warning" | "success"> = {
  normal: "success",
  stable: "success",
  elevated: "warning",
  abnormal: "warning",
  critical: "warning",
};

const formatDate = (value?: string | null) => {
  if (!value || value === "infinity") return undefined;
  try {
    return formatTimeStampToHumanReadableDate(value);
  } catch {
    return undefined;
  }
};

const formatValue = (value?: string | null, unit?: string | null) => {
  if (!value) return undefined;
  return unit ? `${value} ${unit}` : value;
};

type SymptomSummaryCardProps = {
  symptom: SymptomRow;
  onClick?: () => void;
};

export function SymptomSummaryCard({ symptom, onClick }: SymptomSummaryCardProps) {
  const {
    symptom_type,
    symptom_value,
    symptom_unit,
    symptom_range,
    symptom_interpretation,
    created_at,
    updated_at,
  } = symptom;

  const statusTone = symptom_interpretation
    ? interpretationToneMap[symptom_interpretation.toLowerCase()] ?? "default"
    : "default";

  const meta = [
    { label: "Value", value: formatValue(symptom_value, symptom_unit) },
    { label: "Range", value: symptom_range },
    { label: "Recorded", value: formatDate(created_at) },
    { label: "Last updated", value: formatDate(updated_at) },
  ];

  return (
    <MedicalRecordSummaryCard
      title={symptom_type || "Symptom"}
      subtitle={formatValue(symptom_value, symptom_unit)}
      status={symptom_interpretation}
      statusTone={statusTone}
      meta={meta}
      onClick={onClick}
    />
  );
}

export default SymptomSummaryCard;
